import { ContentNode, ContentNodeUtils } from '@helo/cms'
import { Deferred, pipe } from '@helo/utils'

export const TypeRendererParts = {
  isValuePending: (
    contentNode: ContentNode | null | undefined,
    isLoading?: boolean,
  ) => {
    if (isLoading) {
      return true
    }

    if (!contentNode) {
      return false
    }

    if (contentNode.kind === 'FIELD') {
      return TypeRendererParts.isValuePending(contentNode.ofType, false)
    }

    return false
  },
  withPrimaryValue: (contentNode: ContentNode): ContentNode => {
    const primary = ContentNodeUtils.resolvePrimaryValueContentNode(contentNode)
    if (primary === contentNode) {
      return contentNode
    }

    const { primaryValueLocator: _locator, ...presentationState } =
      contentNode.state ?? {}

    return Deferred.merge({
      state: pipe(primary.state ?? {}, Deferred.merge(presentationState)),
    })(primary) as ContentNode
  },
}
